/**
 * VoiceOrb — the central "AURI intelligence" visualization.
 * Renders differently per state: idle | connecting | listening | thinking |
 * speaking. Uses only CSS-transformed layers + SVG — no external deps.
 */
export default function VoiceOrb({ state = "idle", size = 240 }) {
  const stateClass = {
    idle: "voice-orb--idle",
    connecting: "voice-orb--connecting",
    listening: "voice-orb--listening",
    thinking: "voice-orb--thinking",
    speaking: "voice-orb--speaking",
    ready: "voice-orb--ready",
    ended: "voice-orb--idle",
  }[state] || "voice-orb--idle";

  return (
    <div
      className={`voice-orb ${stateClass}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label={`AURI voice state: ${state}`}
      data-testid={`voice-orb-${state}`}
    >
      <div className="voice-orb__glow" />
      <div className="voice-orb__ring voice-orb__ring--outer" />
      <div className="voice-orb__ring voice-orb__ring--mid" />
      <div className="voice-orb__ring voice-orb__ring--inner" />
      <div className="voice-orb__core" />
      <svg className="voice-orb__wave" viewBox="0 0 200 200" aria-hidden="true">
        <defs>
          <linearGradient id="auri-wave-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%"   stopColor="#E4C989" stopOpacity="0.9" />
            <stop offset="55%"  stopColor="#C9A45A" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#B38F46" stopOpacity="0.9" />
          </linearGradient>
        </defs>
        <circle cx="100" cy="100" r="76" fill="none" stroke="url(#auri-wave-grad)" strokeWidth="0.6" opacity="0.75" />
      </svg>
    </div>
  );
}
